import React, { Component } from 'react';

export default class Planel extends Component {

  radioChanged(e, answer, score, redirect){
    this.props.setData(e, answer, score, redirect)
  }
  checkboxChanged(e, answer, score){
    this.props.setData(e, answer, score, false)
  }
	render(){
    const {question, answers, lead, radio, instruction} = this.props.data
    const index = this.props.index
		return (
			<div className={`panel ${this.props.active ? 'active' : ''}`}>
        <h3 className="lead">{lead}</h3>
        <h2 className="question">{question}</h2>
        <span className="instruction">{instruction}</span>
        <ul className="answer">
          { radio &&
            answers.map((answer, i) => {
              return (
                <li key={i} className="radio-wrapper">
                  <input type="radio" id={ "rdQ_" + index +"_"+ i } name={"question_"+ index} value={i} onChange={(e) => this.radioChanged(e, answer.text, answer.score, answer.redirect)} />
                  <label htmlFor={ "rdQ_"+ index+"_"+i }>{answer.text}</label>
                </li>
              )
            })
          }
          { !radio &&
            answers.map((answer, i) => {
              return (
                <li key={i} className="check-wrapper">
                  <input type="checkbox" id={ "ckQ_" + index +"_"+ i } name={"question_"+ index} value={i} onChange={(e) => this.checkboxChanged(e, answer.text, answer.score)}/>
                  <label htmlFor={ "ckQ_"+ index+"_"+i }>{answer.text}</label>
                </li>
              )
            })
          }
        </ul>
        
      </div>
		)	
	}
}	
